import React from 'react';

export const leftQuotesSymbol = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 17" width={24} style={{ display: 'none' }}>
    <symbol id="left-quotes">
      <path
        fill="#007EE5"
        d="M5.3 16.5c0.7 0 1.4-0.1 2-0.4S8.5 15.4 9 15s0.9-1 1.1-1.7 0.4-1.3 0.4-2 -0.1-1.4-0.4-2S9.5 8 9 7.5 8 6.7 7.3 6.4 6 6 5.3 6C5.2 6 5.1 6 5.1 6S4.9 6 4.9 6C4.8 6 4.7 6 4.7 6s-0.1 0-0.2 0C4.5 6 4.6 5.9 4.6 5.8s0.1-0.2 0.2-0.2C4.9 5.5 4.9 5.5 5 5.4s0.1-0.1 0.2-0.2c0.4-0.4 0.7-0.7 1.1-0.9s0.8-0.5 1.3-0.7C8.1 3.4 8.5 3.2 9 3.1S10 3 10.5 3l0 0V0C9 0 7.7 0.3 6.4 0.8S4 2.1 3.1 3.1C2.1 4 1.4 5.1 0.8 6.4S0 9 0 10.5l0 0 0 0.8c0 0.7 0.1 1.4 0.4 2s0.6 1.2 1.1 1.7 1 0.9 1.7 1.1S4.5 16.5 5.3 16.5zM18.8 16.5c0.7 0 1.4-0.1 2-0.4s1.2-0.6 1.7-1.1 0.9-1 1.1-1.7 0.4-1.3 0.4-2 -0.1-1.4-0.4-2S23 8 22.5 7.5s-1-0.9-1.7-1.1S19.5 6 18.8 6c-0.1 0-0.1 0-0.2 0s-0.1 0-0.2 0l0 0 -0.2 0c-0.1 0-0.1 0-0.2 0C18 6 18.1 5.9 18.1 5.8s0.1-0.2 0.2-0.2c0.1-0.1 0.1-0.1 0.2-0.2s0.1-0.1 0.2-0.2c0.4-0.4 0.7-0.7 1.1-0.9s0.8-0.5 1.3-0.7c0.4-0.2 0.9-0.3 1.4-0.4S23.5 3 24 3l0 0V0c-1.5 0-2.8 0.3-4.1 0.8s-2.4 1.3-3.3 2.2c-0.9 1-1.7 2.1-2.2 3.3s-0.8 2.6-0.8 4.1l0 0 0 0.8c0 0.7 0.1 1.4 0.4 2s0.6 1.2 1.1 1.7 1 0.9 1.7 1.1S18 16.5 18.8 16.5z"
      />
    </symbol>
  </svg>
);

export const leftQuotesUse = () => (
  <svg className="mb-0_25" width={24} height={17}>
    <use xlinkHref="#left-quotes" />
  </svg>
);

export const blob80 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 612 471" id="blob-80" className="pos-a">
    <path
      fill="#0069BF"
      d="M612 346.3c-30 32.2-62 60.8-100.2 82.9 -60.3 35.4-136.1 54.9-192.1 29.6 -56-25.3-92.3-95.4-155.8-156.1S9 190.9 0.6 132.2C-5.1 89.6 32.7 42.8 78.2 0L612 0 612 346.3z"
    />
  </svg>
);

export const blob40 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 788 558" id="blob-40" className="pos-a">
    <path
      fill="#0069BF"
      d="M763.3 0c8.4 5.3 16.7 10.9 24.7 16.9l0 399.8c-34.5 28.5-75.2 53.9-117.9 76.5 -93.9 50.2-196.4 86.4-264.4 48.2 -67.6-38.8-100-152.1-165-224.4C175.3 245.2 78.4 213.7 32.6 150.3 3.1 109.2-5.1 54.9 4 0L763.3 0z"
    />
  </svg>
);
